// Route target for Plasmic Studio's "App host". Studio loads this page in
// an iframe to discover any code components registered via a side-effect
// import below, so they can be dragged into the canvas like any other
// Plasmic component.
//
// Keep this page running (npm start) while working in Studio, or deploy
// it and point Studio's App host URL at the deployed /plasmic-host path.
import * as React from "react";
import { PlasmicCanvasHost } from "@plasmicapp/host";
import { DesktopStateProvider } from "./DesktopStateProvider";
import "./plasmic-host-registrations";

// Wrapped in DesktopStateProvider so the Desktop system's code components
// (WindowManagerSurface, ShellAppWindow, SpaceDockButton, AppWindowButton)
// share real, working state when previewed live inside Plasmic Studio's
// canvas - not just once mounted in the real app via App.js.
export default function PlasmicHost() {
  return (
    <DesktopStateProvider>
      <PlasmicCanvasHost />
    </DesktopStateProvider>
  );
}
